export default __webpack_public_path__ + "static/media/245.4a13c06e.png";